import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Subject, takeUntil } from 'rxjs';
import { ErrorConstants } from '../../../constants/error_constants';
import { LeadApi } from '../../api/leadApi';

@Component({
    selector: 'app-completed',
    templateUrl: './completed.component.html',
    styleUrls: ['./completed.component.scss'],
    standalone: false
})

export class CompletedComponent implements OnInit, OnDestroy {

  public status: string = "completed";

  private lead_id: string | null = null;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private route: ActivatedRoute, 
    private recaptchaV3Service: ReCaptchaV3Service,
    private leadApi: LeadApi,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['status']) {
        this.status = params['status'];
      }
    });

    this.lead_id = this.route.snapshot.paramMap.get('lead_id');
    console.log('Lead ID:', this.lead_id);

    if(this.lead_id !== null) {
      try {
        this.recaptchaV3Service.execute('UpdateLeadStatus')
          .pipe(takeUntil(this.destroy$))
          .subscribe((token: any) => {

            const leadData = {
              status_id: 2,
              identifier: this.lead_id,
              recaptcha_token: token,
            }


            this.leadApi.updateLeadStatus(leadData)
              .pipe(takeUntil(this.destroy$))
              .subscribe((response: any) => {
                if (response.success) {
                  sessionStorage.clear();
                } else {
                  console.log('Lead update failed');
                }
              });

          }, (error) => {
            console.log('Error updating lead', error);
          });
      } catch (error) {
        console.log('Error updating lead', error);
      }
    }
    
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
